/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { TemplateReadWithRecords } from "../../models/template-read-with-records";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadTemplate$Params {
  organisation_id: string;
  template_id: number;
}

export function readTemplate(
  http: HttpClient,
  rootUrl: string,
  params: ReadTemplate$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<TemplateReadWithRecords>> {
  const rb = new RequestBuilder(rootUrl, readTemplate.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("template_id", params.template_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TemplateReadWithRecords>;
    }),
  );
}

readTemplate.PATH = "/surfdomeinen/organisations/{organisation_id}/templates/{template_id}";
